import React from 'react'
import { jt, t } from 'ttag'
import * as R from 'ramda'

import { MoveResourceModal } from 'components/modals/common/MoveResourceModal/MoveResourceModal'
import { Detail } from 'components/shared/Detail/Detail'

import { useMoveCandidateGroupModalState } from './hooks'

import styles from './MoveCandidateGroupModal.module.scss'

export const MoveCandidateGroupModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state } = useMoveCandidateGroupModalState()

  const { candidates, count, pks, position } = state

  const message = R.gt(R.length(pks), 0) ? (
    <Detail className={styles.detail} key="candidates">
      <Detail.Content
        chipsClassName={styles.content}
        chips={R.map(({ name }) => name, candidates)}
        type="chipsGroup"
      />
    </Detail>
  ) : null

  return (
    <MoveResourceModal
      alert={jt`You are moving ${count} candidates listed below: ${message}`}
      className={styles.modal}
      title={t`Move candidates`}
      {...{ position, onCancel, onClose, onConfirm, isOpen }}
    />
  )
}
